import type { CinematicId } from "./content";

export interface CinematicMedia {
  webm: string;
  mp4: string;
  poster: string;
}

export const CINEMATIC_MEDIA: Record<CinematicId, CinematicMedia> = {
  opening: { webm: "/cinematics/opening.webm", mp4: "/cinematics/opening.mp4", poster: "/cinematics/opening-poster.jpg" },
  "vaultmouth-intro": { webm: "/cinematics/vaultmouth-intro.webm", mp4: "/cinematics/vaultmouth-intro.mp4", poster: "/cinematics/vaultmouth-intro-poster.jpg" },
  "vaultmouth-death": { webm: "/cinematics/vaultmouth-death.webm", mp4: "/cinematics/vaultmouth-death.mp4", poster: "/cinematics/vaultmouth-death-poster.jpg" },
  "veyra-intro": { webm: "/cinematics/veyra-intro.webm", mp4: "/cinematics/veyra-intro.mp4", poster: "/cinematics/veyra-intro-poster.jpg" },
  "veyra-death": { webm: "/cinematics/veyra-death.webm", mp4: "/cinematics/veyra-death.mp4", poster: "/cinematics/veyra-death-poster.jpg" },
  "seraph-intro": { webm: "/cinematics/seraph-intro.webm", mp4: "/cinematics/seraph-intro.mp4", poster: "/cinematics/seraph-intro-poster.jpg" },
  "seraph-death": { webm: "/cinematics/seraph-death.webm", mp4: "/cinematics/seraph-death.mp4", poster: "/cinematics/seraph-death-poster.jpg" },
  "expedition-death": { webm: "/cinematics/expedition-death.webm", mp4: "/cinematics/expedition-death.mp4", poster: "/cinematics/expedition-death-poster.jpg" },
};
